<template>
  <div class="group-page" v-if="!dataHidden">
    <div class="cf-search">
      <label class="cf-search-title" v-bind="formItemLayout">{{ $t('筛选') }}：</label>
      <!-- <a-spin :spinning="typeLoading">
        <a-select style="width: 120px" :default-value="defaultType" @change="typeChange">
          <a-select-option key="1">{{ $t('按项目筛选') }}</a-select-option>
          <a-select-option key="2">{{ $t('按组别筛选') }}</a-select-option>
        </a-select>
      </a-spin> -->
      <a-spin :spinning="typeLoading">
        <a-select v-model="defaultGroup" mode="multiple" style="width: 240px; margin-left: 10px" :maxTagCount="1" @change="groupChange">
          <a-select-option key="-1">{{ $t('全部项目') }}</a-select-option>
          <a-select-option :disabled="defaultGroup.indexOf('-1') > -1" v-for="item in typeData.combats" :key="item.combatId" :value="item.combatId">{{item.name}}</a-select-option>
        </a-select>
        <a-select v-model="defaultTitleGroup" mode="multiple" style="width: 240px; margin-left: 10px" :maxTagCount="1" @change="groupTitleChange">
          <a-select-option key="-1">{{ $t('全部组别') }}</a-select-option>
          <a-select-option :disabled="defaultTitleGroup.indexOf('-1') > -1" v-for="item in typeData.combatDetails" :key="item.name" :value="item.name">{{item.name}}</a-select-option>
        </a-select>
        <a-select v-model="sexGroup" mode="multiple" style=" margin-left: 10px" :maxTagCount="1" @change="groupSexChange">
          <a-select-option key="-1">{{ $t('全部') }}</a-select-option>
          <a-select-option :disabled="sexGroup.indexOf('-1') > -1" value="1">男子</a-select-option>
          <a-select-option :disabled="sexGroup.indexOf('-1') > -1" value="2">女子</a-select-option>
          <a-select-option :disabled="sexGroup.indexOf('-1') > -1" value="0">混合</a-select-option>
        </a-select>
      </a-spin>
      <a-button icon="search" :loading="dataLoading" type="primary" :style="{marginLeft: '10px', background: (this.$root.skin_number || '')}" @click="queryAgencyMedalRank()">{{ $t('搜索') }}</a-button>
      <a-button icon="download" :loading="dataLoading" :style="{marginLeft: '10px', background: (this.$root.skin_number || '')}" @click="downloadAgencyMedalRank()">{{ $t('下载') }}</a-button>
    </div>
    <a-spin :spinning="dataLoading">
      <div class="table-list" >
        <div class="row table-header">
          <div class="col col-3 text-left">{{ $t('队伍名称') }}</div>
          <div class="col col-1 text-center pointer" @click="sort(0)">
            <img src="../../assets/jin.png">
            <img :src="sortImg[0].img" class="sort"/>
          </div>
          <div class="col col-1 text-center pointer" @click="sort(1)">
            <img src="../../assets/yin.png">
            <img :src="sortImg[1].img" class="sort"/>
          </div>
          <div class="col col-1 text-center pointer" @click="sort(2)">
            <img src="../../assets/tong.png">
            <img :src="sortImg[2].img" class="sort"/>
          </div>
          <div class="col col-1 text-center pointer" @click="sort(3)">
            {{ $t('团体总分') }}
            <img :src="sortImg[3].img" class="sort"/>
          </div>

        </div>
        <template v-for="(item, index) in rankData">
          <div class="row" :key="index" v-if="rankData.length > 0">
            <div class="col col-3">
              <img :src="item.unitLogo || defaultHead" class="table-logo">
              {{ item.unitName }}
            </div>
            <div class="col col-1 text-center">{{ item.rank1 }}</div>
            <div class="col col-1 text-center">{{ item.rank2 }}</div>
            <div class="col col-1 text-center">{{ item.rank3 }}</div>
            <div class="col col-1 text-center">{{ item.totalScore }}</div>
          </div>
        </template>

        <div class="row-empty" v-if="rankData.length == 0">
          <a-empty
            :image="emptyImg"
            :image-style="{height: '30px'}">
            <span slot="description" style="color:#bbbaba;">暂无数据</span>
          </a-empty>
        </div>
      </div>
    </a-spin>
  </div>
  <div class="content" v-else>
    <a-empty
      :image="hiddenImg"
      :image-style="{height: '30px'}">
      <span slot="description" style="color:#bbbaba;">
        <!-- 主办方隐藏了获奖信息 -->
      </span>
    </a-empty>
  </div>
</template>

<script>
export default {
  name: 'group',
  created () {
  },
  mounted () {
    // 初始化
    this.queryAgencyMedalCombat()
    this.queryAgencyMedalRank()
  },
  data () {
    return {
      title: '团体排名',
      typeLoading: false,
      dataLoading: false,
      dataHidden: false,
      hiddenImg: require('../../assets/hidden.png'),
      defaultHead: require('../../assets/photo.png'),
      emptyImg: require('../../assets/empty.png'),
      sortImg: [
        {sort: 'default', img: require('../../assets/sort.png')},
        {sort: 'default', img: require('../../assets/sort.png')},
        {sort: 'default', img: require('../../assets/sort.png')},
        {sort: 'up', img: require('../../assets/sortup.png')}
      ],
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      search_text: '',
      formItemLayout: {
        labelCol: {xs: { span: 24 }, sm: { span: 8 }},
        wrapperCol: {xs: { span: 24 }, sm: { span: 16 }}
      },
      typeData: { combatDetails: [], combats: [] },
      defaultType: '1',
      defaultGroup: ['-1'],
      defaultTitleGroup: ['-1'],
      sexGroup: ['-1'],
      rankData: [],
      serarch: ['residence', { initialValue: ['zhejiang', 'hangzhou', 'xihu'],
        rules: [
          { type: 'array', required: true, message: 'Please select your habitual residence!' }
        ]
      }
      ]
    }
  },
  methods: {
    typeChange (value) {
      this.defaultType = value
      this.defaultGroup = ['-1']
    },
    groupChange (value) {
      if (value.length > 1) {
        var index = value.indexOf('-1')
        if (index > -1) {
          this.defaultGroup = this.defaultGroup.splice(index, 1)
        }
      }
    },
    groupTitleChange (value) {
      if (value.length > 1) {
        var index = value.indexOf('-1')
        if (index > -1) {
          this.defaultTitleGroup = this.defaultTitleGroup.splice(index, 1)
        }
      }
    },
    groupSexChange (value) {
      if (value.length > 1) {
        var index = value.indexOf('-1')
        if (index > -1) {
          this.sexGroup = this.sexGroup.splice(index, 1)
        }
      }
    },
    queryAgencyMedalCombat () {
      this.typeLoading = true
      this.$api.match.queryAgencyMedalCombat({matchId: this.matchId}).then(res => {
        this.typeLoading = false
        if (res.status === 0) {
          this.typeData = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询团体排名
    queryAgencyMedalRank () {
      var params = {
        matchId: this.matchId,
        combatIds: '-1',
        sexs: this.sexGroup.map(item => item).join(','),
        combatDetailNames: '-1'
      }
      var str = this.defaultGroup.map(item => item).join(',')
      if (str !== '') {
        params.combatIds = str
      }
      var strTitle = this.defaultTitleGroup.map(item => item).join(',')
      if (strTitle !== '') {
        params.combatDetailNames = strTitle
      }
    
      // this.dataLoading = true
      this.$api.match.queryAgencyMedalRank(params).then(res => {
        // this.dataLoading = false
        if (res.status === 0) {
          this.rankData = res.data
          this.dataHidden = false
        } else if (res.status === 1102003) {
          this.dataHidden = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查询团体排名
    downloadAgencyMedalRank () {
      var params = {
        matchId: this.matchId,
        sexs: this.sexGroup.map(item => item).join(','),
        combatIds: '-1',
        combatDetailNames: '-1'
      }
      var str = this.defaultGroup.map(item => item).join(',')
      if (str !== '') {
        params.combatIds = str
      }
      var strTitle = this.defaultTitleGroup.map(item => item).join(',')
      if (strTitle !== '') {
        params.combatDetailNames = strTitle
      }
      this.$api.match.downloadAgencyMedalRank(params).then(res => {
        let type = res.type
        // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
        if (type.includes('application/json')) {
          let reader = new FileReader()
          var _this = this
          reader.onload = function (event) {
            let content = reader.result
            let message = JSON.parse(content).msg // 错误信息
            _this.$message.error(message)
          }
          reader.readAsText(res)
        } else {
          let blob = new Blob([res])
          let url = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = url
          link.download = '奖牌榜.xls' // 下载后文件名
          document.body.appendChild(link)
          link.click() // 点击下载
        }
      }).catch(err => {
        console.log(err)
      })
    },
    sort (index) {
      var sortType = this.sortImg[index].sort
      console.log('sortType:', sortType, 'sortImg:', this.sortImg, 'index:', index)
      var img = require('../../assets/sort.png')
      var type = 'default'
      if (sortType === 'default' || sortType === 'down') {
        type = 'up'
        img = require('../../assets/sortup.png')
      } else if (sortType === 'up') {
        type = 'down'
        img = require('../../assets/sortdown.png')
      }
      if (index === 0) {
        this.sortImg = [
          {sort: type, img: img},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')}
        ]
        this.sortData('rank1', type)
      } else if (index === 1) {
        this.sortImg = [
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: type, img: img},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')}
        ]
        this.sortData('rank2', type)
      } else if (index === 2) {
        this.sortImg = [
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: type, img: img},
          {sort: 'default', img: require('../../assets/sort.png')}
        ]
        this.sortData('rank3', type)
      } else if (index === 3) {
        this.sortImg = [
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: 'default', img: require('../../assets/sort.png')},
          {sort: type, img: img}
        ]
        this.sortData('totalScore', type)
      }
    },
    // 数据排序
    sortData (dataType, sortType) {
      this.rankData = this.rankData.sort((a, b) => {
        let adata = a[dataType]
        let bdata = b[dataType]
        if (sortType === 'up') {
          return ((adata < bdata) ? 1 : (adata > bdata) ? -1 : 0)
        } else {
          return ((adata < bdata) ? -1 : (adata > bdata) ? 1 : 0)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-btn-primary {
  border-color: #1890ff00
}
.cf-search{
  width: 1200px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  .cf-search-title{
    line-height: 30px;
    .select {
      width: 120px;
      margin-left: 10px
    }
  }
}
.sort {
  width: 15px;
  margin-left: 5px;
}
.pointer {
  cursor: pointer;
}
.table-list {
 background-color:#fff
}
.table-list .table-header {
 color:#000;
 font-weight:700;
 background-color:#e5e5e5;
 border-bottom:1px solid #e8e8e8
}
.table-list .table-header .col {
 padding:16px 8px!important
}
.table-list .table-header img {
 max-width:20px
}
.table-list .col {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 padding:8px
}
.table-list .col-1 {
 -webkit-box-flex:1;
 -ms-flex:1;
 flex:1
}
.table-list .col-2 {
 -webkit-box-flex:2;
 -ms-flex:2;
 flex:2
}
.table-list .col-3 {
 -webkit-box-flex:3;
 -ms-flex:3;
 flex:3
}
.table-list .col-4 {
 -webkit-box-flex:4;
 -ms-flex:4;
 flex:4
}
.table-list .col-5 {
 -webkit-box-flex:5;
 -ms-flex:5;
 flex:5
}
.table-list .col-6 {
 -webkit-box-flex:6;
 -ms-flex:6;
 flex:6
}
.table-list .text-center {
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 text-align:center
}
.table-list .row {
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-orient:horizontal;
 -webkit-box-direction:normal;
 -ms-flex-direction:row;
 flex-direction:row;
 border-bottom:1px solid #e8e8e8;
 min-height:60px
}
.table-list .row .check-table {
 margin-right:5px
}
.table-list .row .table-logo {
 width:45px;
 height:45px;
 border-radius:50%;
 margin-right:5px;
 border:1px solid #f8f8f8;
 cursor:pointer
}
.table-list .row .btn-del,
.table-list .row .btn-jj,
.table-list .row .btn-tg {
 cursor:pointer;
 border:1px solid #e8e8e8;
 margin:0 5px;
 padding:0 5px;
 border-radius:2px
}
.table-list .row .btn-tg {
 color:#42ad00
}
.table-list .row .btn-tg:hover {
 color:#fff;
 border:1px solid #42ad00;
 background-color:#42ad00
}
.table-list .row .btn-jj {
 color:#f14f2b
}
.table-list .row .btn-jj:hover {
 color:#fff;
 border:1px solid #f14f2b;
 background-color:#f14f2b
}
.table-list .row .btn-del {
 color:#000
}
.table-list .row .btn-del:hover {
 color:#fff;
 border:1px solid #000;
 background-color:#000
}
.table-list .row-empty {
 color:rgba(0,0,0,.25);
 border:1px solid #e8e8e8;
 border-top:none;
 min-height:160px;
 display:-webkit-box;
 display:-ms-flexbox;
 display:flex;
 -webkit-box-align:center;
 -ms-flex-align:center;
 align-items:center;
 -webkit-box-pack:center;
 -ms-flex-pack:center;
 justify-content:center;
 -webkit-box-orient:vertical;
 -webkit-box-direction:normal;
 -ms-flex-direction:column;
 flex-direction:column;
 background-color:#fff
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/group.vue